import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import _PropTypes from 'prop-types';
import * as React from 'react';
import styled from 'styled-components';
import { spacing6x } from '../../styles/spacing.js';
import { useAccordionContext } from '../AccordionContext/AccordionContext.js';
import { useAccordionDndContext } from '../AccordionDndContext/AccordionDndContext.js';
import { StyledDropBar } from '../AccordionDndContext/DragAccordion.js';
import { useAccordionItemContext } from '../AccordionItemContext/AccordionItemContext.js';
import { useAccordionItemDndContext } from '../AccordionItemDndContext/AccordionItemDndContext.js';
import { Box } from '../Box/Box.js';
import { jsxs, Fragment, jsx } from 'react/jsx-runtime';

var _excluded = ["children"];
var StyledBox = styled(Box).withConfig({
  displayName: "AccordionItem__StyledBox",
  componentId: "sc-1fy2kn6-0"
})(["&&{margin-bottom:", ";width:", ";min-height:60px;overflow:hidden;", ";", ";}"], spacing6x, function (_ref) {
  var $variant = _ref.$variant;
  return $variant === "embedded" || $variant === "fullwidth" ? "100%" : "320px";
}, function (_ref2) {
  var $variant = _ref2.$variant,
      theme = _ref2.theme;
  return $variant === "embedded" ? "\n    border: none;\n    border-top-color: ".concat(theme.neutralColors.silver, ";\n    border-top-width: 1px;\n    border-top-style: solid;\n    margin-bottom: 0;\n    &:first-of-type {\n        border: none;\n    }\n    ") : "";
}, function (_ref3) {
  var isDragPlaceholder = _ref3.isDragPlaceholder,
      theme = _ref3.theme;
  return isDragPlaceholder ? "background-color: ".concat(theme.neutralColors.pearl, "\n            ") : "";
});
var AccordionItem = /*#__PURE__*/React.forwardRef(function AccordionItem2(props, ref) {
  var children = props.children,
      rest = _objectWithoutProperties(props, _excluded);

  var _useAccordionContext = useAccordionContext(),
      $variant = _useAccordionContext.variant;

  var _useAccordionItemCont = useAccordionItemContext(),
      isLastIndex = _useAccordionItemCont.isLastIndex;

  var dndContext = useAccordionDndContext();
  var itemDndContext = useAccordionItemDndContext();
  var isBorderless = $variant === "embedded";
  return /*#__PURE__*/jsxs(Fragment, {
    children: [(dndContext === null || dndContext === void 0 ? void 0 : dndContext.onDragChange) && itemDndContext && /*#__PURE__*/jsx(StyledDropBar, {
      position: "top",
      isDragOver: itemDndContext.isDragOverTopBar && itemDndContext.canDropTopBar,
      ref: itemDndContext.connectDropTopBarTarget
    }), /*#__PURE__*/jsx(StyledBox, _objectSpread(_objectSpread({
      $variant: $variant,
      isDragPlaceholder: itemDndContext === null || itemDndContext === void 0 ? void 0 : itemDndContext.isDragging,
      borderRadius: isBorderless ? 0 : 1,
      elevation: isBorderless ? void 0 : 1,
      ref: ref
    }, rest), {}, {
      children: children
    })), (dndContext === null || dndContext === void 0 ? void 0 : dndContext.onDragChange) && itemDndContext && isLastIndex && /*#__PURE__*/jsx(StyledDropBar, {
      position: "bottom",
      isDragOver: itemDndContext.isDragOverBottomBar && itemDndContext.canDropBottomBar,
      ref: itemDndContext.connectDropBottomBarTarget
    })]
  });
});
AccordionItem.propTypes = {
  "children": _PropTypes.node
};
AccordionItem.displayName = "AccordionItem";

export { AccordionItem };
